export default __webpack_public_path__ + "alberta-report.027619d12b231f6436ee.svg";